module.exports = __webpack_public_path__ + "img/a.4a182069.jpg";